import { Component } from "react";
import { Link } from "react-router-dom";
import axiosInstance from "../../../axiosInstance";
import { containsPermission } from "../../helper";

const { default: MUIDataTable } = require("mui-datatables");


const columns = [
    {
        "name" : "type",
        "label" : "ტიპი",
    },
    {
        "name" : "stage",
        "label" : "მდგომარეობა",
    },
    {
        "name" : "role",
        "label" : "როლი",
    },
    {
        "name" : "next_stage",
        "label" : "შემდეგი მდგომარეობა",
    },
    {
        "name" : "owner_action",
        "label" : "მფლობელობის",
    },
    {
        "name" : "user_only",
        "label" : "User only",
    }
    
]
class DashboardSettings extends Component{
    constructor(props){
        super(props);
        this.onRowsDelete = this.onRowsDelete.bind(this);
        this.onRowSelectionChange = this.onRowSelectionChange.bind(this);
        this.state = {
            data:[],
            selected_setting:null,
            options:{
                filterType: 'checkbox',
                selectableRowsHeader:false,
                expandableRowsHeader:false,
                viewColumns:false,
                print:false,
                filter:false,
                selectableRows:'single',
                onRowsDelete:this.onRowsDelete,
                onRowSelectionChange:this.onRowSelectionChange,
            }
        }
    }


    componentDidMount(){
        this.fetch_settings();
    }

    fetch_settings(){
        axiosInstance.get('tickets/dashboard/permissions')
        .then(response => {
            this.setState({
                data:response.data.data 
            })
        })
        .catch(error => {
            console.error(error);
        })
    }

    onRowsDelete(rowsDeleted){
        let id = this.state.data[rowsDeleted.data[0].dataIndex].id
        axiosInstance.delete('tickets/dashboard/permissions/'+id)
        .then(response=>{
            this.fetch_settings();
        })
        .catch(error => {
            if(error.response.status == 400){
                this.on_bad_request(error.response.data);
            }
        });

        return true;
        
    }
    onRowSelectionChange(currentRowsSelected){
        this.setState({
            ...this.state,
            selected_setting:this.state.data[currentRowsSelected[0].dataIndex].id,
            response:{
                isInvalid:false,
                isValid:false
            }
        })
    }
    render(){
        let add_setting = null;
        if(containsPermission(this.props.role_permissions,'dashboard_settings.add')){
            add_setting = <Link  to = "/dashboard_settings/new"  id = "create_new_btn" className="btn btn-dark" > ახლის დამატება</Link>;
        }
        return(
            <div className="content-main">
                {add_setting}
                <MUIDataTable
                title = "Settings"
                options = {this.state.options}
                data = {this.state.data}
                columns = {columns}
                />
            </div>
            
        )
    }
}

export default DashboardSettings;